import React, { ReactNode, useCallback, useMemo } from 'react'
import { getListSectionSortedAndGroupedUsers } from '../../../helpers/user'
import { ResidentListItem } from './ResidentListItem'
import { Section, SectionList } from '../../common/SectionList'
import { ResidentUserType } from '../../../state/stores/units'
import { IUserModel } from '../../../interfaces/models/users.interfaces'
import { ISocietiesModel } from '../../../interfaces/models/societies.interfaces'

interface ResidentListProps {
  users: IUserModel[]
  society: ISocietiesModel | undefined
  editUserUnitsMode?: ResidentUserType
  deleteUserOption?: boolean
}

export const ResidentList = ({
  users,
  society,
  editUserUnitsMode,
  deleteUserOption = false,
}: ResidentListProps): ReactNode => {
  const usersList = useMemo(
    () => getListSectionSortedAndGroupedUsers(users),
    [users]
  )

  const getSections = useCallback((): Section[] => {
    return usersList.map((section) => ({
      title: section.title,
      item: (
        <div>
          {section.data.map((user) => (
            <ResidentListItem
              key={user._id}
              user={user}
              society={society}
              editUserUnitsMode={editUserUnitsMode}
              deleteUserOption={deleteUserOption}
            />
          ))}
        </div>
      ),
    }))
  }, [usersList, society, editUserUnitsMode, deleteUserOption])

  return <SectionList sections={getSections()} />
}
